(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ezy-caravan-modal"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.querySelector('[data-ezy-caravan-modal]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const steps = dialog.querySelector('[data-ezy-steps]');

    const open = () => {
      // Always start from Series — reopening mid-cascade is disorienting.
      steps?.dispatchEvent(new CustomEvent('ezy:reset'));
      if (!dialog.open) dialog.showModal();
    };
    window.ezyOpenCaravanModal = open;

    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-ezy-modal-close]')) {
        dialog.close();
        return;
      }
      // Any link to the selector page opens the dialog instead. The page itself
      // stays reachable — hold a modifier, or follow the bypass link inside.
      const link = event.target.closest('a[href*="shop-by-caravan"]');
      if (!link || link.hasAttribute('data-ezy-modal-bypass')) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
      // On the selector page itself the stepper is already there; do not cover it.
      if (window.location.pathname.includes('shop-by-caravan')) return;
      event.preventDefault();
      open();
    });

    // Clicking the backdrop closes it; <dialog> reports those clicks on itself.
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ezy-caravan-steps"] && !Shopify.designMode) return;
  try {
    (() => {
    const source = document.getElementById('ezy-tree');
    if (!source) return;
    const tree = JSON.parse(source.textContent);
    const uniq = (list) => [...new Set(list)].sort();

    const marksFor = (series) =>
      uniq(tree.filter((t) => t.series === series && t.mark).map((t) => t.mark));
    const modelsFor = (series, mark) =>
      tree.filter((t) => t.series === series && (mark === '' ? !t.mark : t.mark === mark));

    document.querySelectorAll('[data-ezy-steps]').forEach((root) => {
      const chips = root.querySelector('[data-ezy-chips]');
      const label = root.querySelector('[data-ezy-label]');
      const hint = root.querySelector('[data-ezy-hint]');
      const back = root.querySelector('[data-ezy-back]');
      const copy = {
        pickSeries: root.dataset.pickSeries,
        pickMark: root.dataset.pickMark,
        pickModel: root.dataset.pickModel,
        hintSeries: root.dataset.hintSeries,
        hintMark: root.dataset.hintMark,
        hintModel: root.dataset.hintModel,
      };
      const steps = {
        series: root.querySelector('[data-ezy-step="series"]'),
        mark: root.querySelector('[data-ezy-step="mark"]'),
        model: root.querySelector('[data-ezy-step="model"]'),
      };
      let state = { series: null, mark: null };

      const setSteps = (active) => {
        Object.entries(steps).forEach(([key, el]) => {
          if (!el) return;
          if (key === active) el.setAttribute('aria-current', 'step');
          else el.removeAttribute('aria-current');
        });
        steps.series?.toggleAttribute('data-done', Boolean(state.series));
        steps.mark?.toggleAttribute('data-done', Boolean(state.mark));
      };

      const paint = (values, onPick) => {
        chips.innerHTML = '';
        values.forEach((value) => {
          const button = document.createElement('button');
          button.className = 'ezysteps__chip';
          button.type = 'button';
          button.textContent = value;
          button.addEventListener('click', () => onPick(value));
          chips.appendChild(button);
        });
      };

      const render = () => {
        back.hidden = !state.series;

        if (!state.series) {
          setSteps('series');
          label.textContent = copy.pickSeries || label.textContent;
          hint.textContent = copy.hintSeries || '';
          paint(uniq(tree.map((t) => t.series)), (value) => {
            state.series = value;
            // Airlie and VZ4800 have no Mark — skip the step, do not show it empty.
            if (!marksFor(value).length) state.mark = '';
            render();
          });
          return;
        }

        if (state.mark === null) {
          setSteps('mark');
          label.textContent = copy.pickMark || '';
          hint.textContent = copy.hintMark || '';
          paint(marksFor(state.series), (value) => { state.mark = value; render(); });
          return;
        }

        setSteps('model');
        label.textContent = copy.pickModel || '';
        hint.textContent = copy.hintModel || '';
        const list = modelsFor(state.series, state.mark);
        paint(list.map((t) => t.model), (value) => {
          const hit = list.find((t) => t.model === value);
          if (hit) window.ezyChooseCaravan(hit.handle);
        });
      };

      back.addEventListener('click', () => {
        if (state.mark !== null && marksFor(state.series).length) state.mark = null;
        else state = { series: null, mark: null };
        render();
      });

      root.addEventListener('ezy:reset', () => { state = { series: null, mark: null }; render(); });
      render();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ezy-exploded-hero"] && !Shopify.designMode) return;
  try {
    (function exploded() {
    const root = document.querySelector('[data-ezyxv]');
    if (!root) return;
    const stage = root.querySelector('[data-ezyxv-stage]');
    const canvas = root.querySelector('[data-ezyxv-canvas]');
    const base = root.querySelector('.ezyxv__base');
    const shade = root.querySelector('[data-ezyxv-shade]');
    const van = root.querySelector('.ezyxv__car');
    const ink = root.querySelector('[data-ezyxv-ink]');
    const svg = root.querySelector('[data-ezyxv-lines]');
    const parts = [...root.querySelectorAll('[data-ezyxv-part]')];
    const dots = [...root.querySelectorAll('.ezyxv__dot')];
    const tags = [...root.querySelectorAll('.ezyxv__tag')];
    const copy = root.querySelector('[data-ezyxv-copy]');
    const hint = root.querySelector('[data-ezyxv-hint]');
    const ctas = root.querySelector('.ezyxv__ctas');
    const mark = root.querySelector('[data-ezyxv-mark]');
    const still = matchMedia('(prefers-reduced-motion: reduce)');
    const num = (s) => s.split(',').map(Number);
    const items = parts.map((el, i) => {
      const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      svg.appendChild(line);
      return { el, line, dot: dots[i], tag: tags[i], img: el.querySelector('img'),
               from: num(el.dataset.from), to: num(el.dataset.to), m: num(el.dataset.m), mm: +el.dataset.mm };
    });

    // Timeline in arbitrary units; T is its length, the last 0.2 a hold on the exploded view.
    // Every part leaves and lands together, however long its line (owner, 2026-10-12).
    const T = 0.92, AT = 0.15;
    // Off the van, % of photo width per real mm: the 790 mm tyre lands at 8%,
    // about 2.25x its size on the van (owner asked twice for parts 1.5x larger, 2026-10-12).
    const MM = 7.95 / 790;
    const clamp = (v) => Math.min(1, Math.max(0, v));
    const ease = (v) => 1 - (1 - v) * (1 - v);
    const lerp = (a, b, k) => a + (b - a) * k;
    const ratio = (img) => img.naturalHeight / img.naturalWidth || 1;
    let corner = null; // how far the buttons glide from under the headline to the corner

    function size() {
      // The stage sticks just under the opaque bands of the fixed header, the same
      // offset the header gives #header-group. A see-through nav row still floats
      // over the stage (and turns solid on scroll), so nothing lands under it.
      const head = document.querySelector('[data-ezy-head]');
      const group = document.querySelector('#header-group');
      const top = group ? parseFloat(getComputedStyle(group).paddingTop) || 0 : 0;
      const nav = head ? Math.max(0, head.offsetHeight - top) : 0;
      root.style.setProperty('--ezyxv-top', top + 'px');
      root.style.setProperty('--ezyxv-h', `calc(100svh - ${top}px)`);
      root.style.setProperty('--ezyxv-nav', nav + 'px');

      const W = stage.clientWidth, H = stage.clientHeight;
      const tall = W / H < 1.25 || W <= 760;
      root.classList.toggle('ezyxv--tall', tall);
      // Buttons back in their corner, side by side, to be measured.
      root.classList.remove('ezyxv--wall', 'ezyxv--stack');
      Object.assign(ctas.style, { left: '', top: '' });
      root.style.setProperty('--ezyxv-ctash', ctas.offsetHeight + 'px');
      const x = Math.min(64, Math.max(24, 0.03 * W)), gap = Math.max(24, 0.025 * W);
      let cw, cl, ct;
      if (tall) { // the van fills a phone: photo ~3x the screen wide, centred on the van
        // Measure the band the van, the landed parts and their labels need (as a
        // fraction of the photo width), then shrink the photo if a short screen
        // can't hold it, and centre it between the nav and the button card, so no
        // part or label lands under either (owner, 2026-10-12, phone screenshot).
        // The headline only has to clear the van while it is still in one piece
        // (it fades before the parts arrive).
        const room = hint.offsetTop - nav - 16; // the cue sits just above the buttons
        const vanTop = 0.1357 / 3, need = copy.offsetTop + copy.offsetHeight + 12;
        let lo = vanTop, hi = 0.804 / 3, tagUp = 0, tagDown = 0;
        items.forEach((it) => {
          const cy = it.m[1] / 300, hh = it.mm * MM / 100 * ratio(it.img) / 2;
          lo = Math.min(lo, cy - hh); hi = Math.max(hi, cy + hh);
          const th = it.tag.offsetHeight + 6;
          if (it.m[1] < 13.57) tagUp = Math.max(tagUp, th); else tagDown = Math.max(tagDown, th);
        });
        const bottom = nav + 8 + room - tagDown; // lowest a landed label may reach
        cw = Math.min(3.15 * W, (room - tagUp - tagDown) / (hi - lo), (bottom - need) / (hi - vanTop));
        cl = W / 2 - 0.5 * cw;
        ct = nav + 8 + tagUp + (room - tagUp - tagDown - (hi - lo) * cw) / 2 - lo * cw;
        ct = Math.min(Math.max(ct, need - vanTop * cw), bottom - hi * cw);
      } else {              // the photo fills the whole stage, behind the nav too, so there is
        // no dark band under the nav; only the workshop at the sides is cropped.
        // Wider than 3:1, fill the width instead.
        cw = Math.max(3 * H, W); cl = (W - cw) / 2; ct = (H - cw / 3) / 2;
        // Laptops: too little wall right of the van for the headline block, so the photo
        // slides left a little (at most 8% of the screen).
        const strip = W - x - (cl + 0.664 * cw + gap);
        cl -= Math.min(0.08 * W, Math.max(0, 340 - strip), (cw - W) / 2);
      }
      const ch = cw / 3;
      Object.assign(canvas.style, { width: cw + 'px', left: cl + 'px', top: ct + 'px' });
      // The painted emblem is centred on the van's front edge, so the van hides part of
      // it (owner, 2026-10-13); left out where too little of it would show (phones,
      // near-square screens).
      // The emblem image is 2582 x 2284 with 160 px of overspray round a 2262 x 1964 emblem.
      const wall = cl + 0.3362 * cw;
      const eh = 0.34 * ch, iw = eh * 2582 / 1964, pad = iw * 160 / 2582, ew = iw - 2 * pad;
      const ex = Math.max(x, wall - ew / 2);
      mark.hidden = tall || wall - ex < 0.25 * ew; // the van's nose slopes back, so more shows than this
      if (!mark.hidden) Object.assign(mark.style, { width: iw + 'px', left: ex - pad - cl + 'px', top: 0.14 * ch - pad + 'px' });
      // Headline, promise and buttons as one centred block on the wall right of the van,
      // a little below the emblem's middle (owner, 2026-10-13). A strip too narrow even
      // for the buttons stacked: headline bottom left, buttons bottom right, as before.
      const L = cl + 0.664 * cw + gap, col = W - x - L;
      const row = ctas.offsetWidth, least = Math.max(...[...ctas.children].map((a) => a.offsetWidth)) + 12;
      const onWall = !tall && col >= least;
      root.classList.toggle('ezyxv--wall', onWall);
      root.classList.toggle('ezyxv--stack', onWall && row > col);
      corner = null;
      if (onWall) {
        // One line where it fits ("GENUINE PARTS" runs about 10.6 em wide); in a narrower
        // strip, larger on two lines ("GENUINE" about 6.2 em).
        const line = col / 10.6;
        copy.style.setProperty('--ezyxv-hsize', Math.min(60, line >= 44 ? line : col / 6.2) + 'px');
        Object.assign(copy.style, { left: L + 'px', width: col + 'px' });
        const sp = 40, top = Math.max(nav + 24, ct + 0.42 * ch - (copy.offsetHeight + sp + ctas.offsetHeight) / 2);
        const bx = L + (col - ctas.offsetWidth) / 2, by = top + copy.offsetHeight + sp;
        copy.style.top = top + 'px';
        Object.assign(ctas.style, { left: bx + 'px', top: by + 'px' });
        // As the van opens the buttons glide to the corner, clear of the landing parts.
        corner = [W - 40 - ctas.offsetWidth - bx, H - 40 - ctas.offsetHeight - by];
      } else {
        Object.assign(copy.style, { left: '', width: '', top: '' });
      }
      svg.setAttribute('viewBox', `0 0 ${W} ${H}`);

      const photo = (p) => [cl + p[0] / 100 * cw, ct + p[1] / 100 * ch, p[2] / 100 * cw];
      items.forEach((it) => {
        it.a = photo(it.from);
        it.b = photo(tall ? it.m : it.to); // a short hop off the van, not across the screen
        it.b[2] = it.mm * MM / 100 * cw; // true proportions, one scale for every part
        // The label sits under its part (owner, 2026-10-12); on tall screens, over the
        // parts that land above the van's roof (13.57% down the photo), so no label
        // covers the roof's dots (owner, 2026-10-13, phone screenshot).
        it.up = tall && it.m[1] < 13.57;
      });
      placeTags(W, tall ? hint.offsetTop - 8 : H - 8, nav);
      render();
    }

    function placeTags(W, floor, nav) {
      const box = items.map(({ img, tag, b, up }) => {
        const [bx, by, pw] = b, ph = pw * ratio(img) / 2, h = tag.offsetHeight;
        const y = up ? by - ph - 6 - h : by + ph + 6;
        // never under the nav or the buttons
        return { tag, x: bx, y: Math.min(Math.max(y, nav + 8), floor - h), w: tag.offsetWidth, h };
      });
      // Labels on one row are pushed 12px apart, so a finger lands on the one it means
      // (owner, 2026-10-13: three ran end to end on a phone); and kept on screen.
      box.sort((p, q) => p.x - q.x);
      for (let pass = 0; pass < 4; pass++) {
        box.forEach((p, i) => box.slice(i + 1).forEach((q) => {
          if (p.y > q.y + q.h + 16 || q.y > p.y + p.h + 16) return; // not on one row
          const d = (p.w + q.w) / 2 + 12 - (q.x - p.x);
          if (d > 0) { p.x -= d / 2; q.x += d / 2; }
        }));
        box.forEach((p) => { p.x = Math.min(Math.max(p.x, p.w / 2 + 8), W - p.w / 2 - 8); });
      }
      box.forEach(({ tag, x, y }) => { tag.style.left = x + 'px'; tag.style.top = y + 'px'; });
    }

    function progress() {
      if (still.matches) return 1;
      const run = root.offsetHeight - stage.offsetHeight;
      const top = parseFloat(root.style.getPropertyValue('--ezyxv-top')) || 0;
      return run > 0 ? clamp((top - root.getBoundingClientRect().top) / run) : 1;
    }

    function render() {
      const t = progress() * T;
      const k = clamp((t - 0.05) / 0.6);
      base.style.filter = `brightness(${1 - 0.45 * k}) saturate(${1 - 0.35 * k}) blur(${1.5 * k}px)`;
      van.style.filter = `brightness(${1 - 0.6 * k}) saturate(${1 - 0.4 * k})`;
      shade.style.opacity = k;
      mark.style.opacity = 0.74 - 0.6 * k; // under the headline in weight; dims with the workshop
      // Fully drawn during the intro sweep and while dragged; otherwise it follows the explosion.
      ink.style.opacity = grab || !drawn ? 0.9 : 0.85 * k;
      const c = clamp(k / 0.25);
      copy.style.opacity = 1 - c;
      copy.style.translate = `0 ${-12 * c}px`;
      ctas.style.translate = corner ? `${corner[0] * ease(c)}px ${corner[1] * ease(c)}px` : '';
      items.forEach((it) => {
        if (!it.a) return;
        const at = AT;
        const e = ease(clamp((t - at) / 0.45));
        const x = lerp(it.a[0], it.b[0], e), y = lerp(it.a[1], it.b[1], e), w = lerp(it.a[2], it.b[2], e);
        Object.assign(it.dot.style, { left: it.a[0] + 'px', top: it.a[1] + 'px',
                                      opacity: clamp((t - 0.08) / 0.1) });
        Object.assign(it.el.style, { left: x + 'px', top: y + 'px', width: w + 'px', opacity: clamp((t - at) / 0.06) });
        it.line.setAttribute('x1', it.a[0]); it.line.setAttribute('y1', it.a[1]);
        it.line.setAttribute('x2', x); it.line.setAttribute('y2', y);
        it.line.style.opacity = t > at ? 1 : 0;
        it.tag.style.opacity = clamp((t - at - 0.38) / 0.12);
        it.tag.style.pointerEvents = t > at + 0.38 ? 'auto' : 'none';
      });
    }

    // The intro sweep is CSS; once it ends the sketch eases out to its scroll-driven value.
    let drawn = still.matches;
    ink.addEventListener('animationend', () => { drawn = true; render(); }, { once: true });

    // Drag: a little give, eased by tanh so it never runs away, and none once the parts
    // are out (they are pinned to points on the photo).
    let grab = null;
    const nudge = (dx, dy) => {
      const k = 1 - clamp(progress() / 0.15);
      const x = 60 * Math.tanh(dx / 180) * k, y = 16 * Math.tanh(dy / 180) * k;
      van.style.translate = `${x}px ${y}px`;
      van.style.rotate = `${x * 0.02}deg`;
      ink.style.translate = `${x * 1.8}px ${y * 1.8}px`;
      ink.style.rotate = `${x * 0.035}deg`;
    };
    stage.addEventListener('pointerdown', (e) => {
      if (e.button || e.target.closest('a')) return;
      grab = [e.clientX, e.clientY];
      root.classList.add('ezyxv--drag');
      stage.setPointerCapture(e.pointerId);
      render();
    });
    stage.addEventListener('pointermove', (e) => {
      if (grab) nudge(e.clientX - grab[0], e.clientY - grab[1]);
    });
    const release = () => {
      if (!grab) return;
      grab = null;
      root.classList.remove('ezyxv--drag');
      nudge(0, 0);
      render();
    };
    stage.addEventListener('pointerup', release);
    stage.addEventListener('pointercancel', release);

    let queued = false;
    const onScroll = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; render(); });
    };
    // Horizon scrolls .page-wrapper, not the window; a capturing listener sees either.
    document.addEventListener('scroll', onScroll, { capture: true, passive: true });
    addEventListener('resize', size, { passive: true });
    still.addEventListener('change', size);

    const imgs = [...root.querySelectorAll('img')];
    Promise.all(imgs.map((im) => (im.complete ? 0 : new Promise((r) => { im.onload = im.onerror = r; })))).then(size);
    items.forEach(({ img }) => img.complete || img.addEventListener('load', size, { once: true }));
    size();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ezy-part-card"] && !Shopify.designMode) return;
  try {
    // The badge sits inside the card's anchor, so a click has to be stopped from
  // navigating to the product before the picker can open. Enter and Space are
  // wired too — role=button promises keyboard operation, so it has to keep it.
  (() => {
    const open = (event) => {
      const badge = event.target.closest('[data-ezy-check-fitment]');
      if (!badge) return;
      event.preventDefault();
      event.stopPropagation();
      if (typeof window.ezyOpenCaravanModal === 'function') {
        window.ezyOpenCaravanModal();
      } else {
        window.location.href = window.Shopify.routes.root + 'pages/shop-by-caravan';
      }
    };
    document.addEventListener('click', open);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') open(event);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ezy-pickup"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    if (event.target.closest('[data-ezy-pickup-open]')) {
      const drawer = document.querySelector('[data-ezy-pickup]');
      if (!drawer) return;
      drawer.showModal();
      // showModal parks focus on the first focusable child — the close button —
      // which then opens wearing a focus ring that reads as "selected". The
      // autofocus attribute alone does not move it, so take focus explicitly.
      drawer.focus();
      return;
    }
    if (event.target.closest('[data-ezy-pickup-close]')) {
      document.querySelector('[data-ezy-pickup]')?.close();
      return;
    }
    // Clicking the backdrop lands on the dialog element itself, never on its
    // children, so this closes on outside-click without a wrapper div.
    const drawer = event.target.closest('[data-ezy-pickup]');
    if (drawer && event.target === drawer) drawer.close();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ezy-search-box"] && !Shopify.designMode) return;
  try {
    (() => {
    // Verified on this store: without variants.sku the predictive endpoint returns
    // nothing for a part number. Barcode is included for the same reason.
    const FIELDS = 'title,product_type,variants.title,variants.sku,variants.barcode,vendor,tag';
    const DEBOUNCE_MS = 180;
    const MIN_CHARS = 2;

    // The predictive endpoint returns price as a decimal STRING ("655.00"), not
    // cents like the cart APIs do. Treating it as cents rendered $6.55.
    const money = (value) =>
      new Intl.NumberFormat('en-AU', { style: 'currency', currency: window.Shopify?.currency?.active || 'AUD' })
        .format(parseFloat(value));

    const escapeHtml = (value) =>
      String(value ?? '').replace(/[&<>"']/g, (c) =>
        ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

    document.querySelectorAll('[data-ezy-search]').forEach((form) => {
      const scope = form.closest('.ezysb');
      const input = form.querySelector('[data-ezy-search-input]');
      const clear = form.querySelector('[data-ezy-search-clear]');
      const panel = scope.querySelector('[data-ezy-search-panel]');
      const results = scope.querySelector('[data-ezy-search-results]');
      const status = scope.querySelector('[data-ezy-search-status]');
      let timer = null;
      let controller = null;
      let rows = [];
      let cursor = -1;

      const close = () => {
        panel.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        cursor = -1;
      };

      const open = () => {
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      };

      const move = (delta) => {
        if (!rows.length) return;
        if (cursor >= 0) rows[cursor].removeAttribute('data-active');
        cursor = (cursor + delta + rows.length) % rows.length;
        rows[cursor].setAttribute('data-active', '');
        rows[cursor].scrollIntoView({ block: 'nearest' });
      };

      const render = (data, term) => {
        const found = data.resources.results;
        const products = found.products || [];
        const collections = found.collections || [];
        const queries = found.queries || [];
        const pages = found.pages || [];
        const parts = [];

        if (queries.length) {
          parts.push('<div class="ezysb__group"><h2 class="ezysb__h">Suggestions</h2>' +
            queries.map((q) => `<a class="ezysb__row ezysb__row--term" href="${escapeHtml(q.url)}">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>
              ${escapeHtml(q.text)}</a>`).join('') + '</div>');
        }

        if (products.length) {
          parts.push('<div class="ezysb__group"><h2 class="ezysb__h">Parts</h2>' +
            products.map((product) => {
              const image = product.featured_image?.url || product.image;
              return `<a class="ezysb__row" href="${escapeHtml(product.url)}">
                <span class="ezysb__thumb">${image ? `<img src="${escapeHtml(image)}" alt="" loading="lazy">` : ''}</span>
                <span class="ezysb__meta">
                  <span class="ezysb__title">${escapeHtml(product.title)}</span>
                  ${product.type ? `<span class="ezysb__sku">${escapeHtml(product.type)}</span>` : ''}
                </span>
                <span class="ezysb__price">${money(product.price)}</span>
              </a>`;
            }).join('') + '</div>');
        }

        const extras = [...collections, ...pages];
        if (extras.length) {
          parts.push('<div class="ezysb__group"><h2 class="ezysb__h">Categories &amp; pages</h2>' +
            extras.map((item) => `<a class="ezysb__row ezysb__row--term" href="${escapeHtml(item.url)}">
              ${escapeHtml(item.title)}</a>`).join('') + '</div>');
        }

        if (!parts.length) {
          results.innerHTML = `<div class="ezysb__none">
            <p>No parts match “${escapeHtml(term)}”</p>
            <span>Part numbers change over the life of a model —
              <a href="/pages/parts-enquiry">ask our Parts team</a> to look it up.</span>
          </div>`;
        } else {
          const url = `${window.Shopify.routes.root}search?q=${encodeURIComponent(term)}`;
          results.innerHTML = parts.join('') +
            `<a class="ezysb__all" href="${url}">View all results for “${escapeHtml(term)}”</a>`;
        }

        rows = [...results.querySelectorAll('a')];
        cursor = -1;
        status.textContent = products.length
          ? `${products.length} suggestions available`
          : 'No suggestions';
        open();
      };

      const lookup = async (term) => {
        controller?.abort();
        controller = new AbortController();
        const url = `${window.Shopify.routes.root}search/suggest.json` +
          `?q=${encodeURIComponent(term)}` +
          `&resources[type]=query,product,collection,page` +
          `&resources[limit]=6&resources[limit_scope]=each` +
          `&resources[options][unavailable_products]=last` +
          `&resources[options][fields]=${FIELDS}`;
        try {
          const response = await fetch(url, { signal: controller.signal });
          render(await response.json(), term);
        } catch (error) {
          if (error.name !== 'AbortError') close();
        }
      };

      input.addEventListener('input', () => {
        const term = input.value.trim();
        clear.hidden = term === '';
        clearTimeout(timer);
        if (term.length < MIN_CHARS) { close(); return; }
        timer = setTimeout(() => lookup(term), DEBOUNCE_MS);
      });

      input.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          if (panel.hidden) return;
          event.preventDefault();
          move(event.key === 'ArrowDown' ? 1 : -1);
        } else if (event.key === 'Enter' && cursor >= 0) {
          event.preventDefault();
          rows[cursor].click();
        } else if (event.key === 'Escape') {
          close();
          input.blur();
        }
      });

      input.addEventListener('focus', () => {
        if (input.value.trim().length >= MIN_CHARS && results.innerHTML) open();
      });

      clear.addEventListener('click', () => {
        input.value = '';
        clear.hidden = true;
        close();
        input.focus();
      });

      document.addEventListener('click', (event) => {
        if (!scope.contains(event.target)) close();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ezy-select"] && !Shopify.designMode) return;
  try {
    (() => {
    const CARET = '<svg class="ezysel__caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';
    const TICK = '<svg class="ezysel__tick" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
    let seq = 0;

    const enhance = (select) => {
      if (select.dataset.ezySelReady) return;
      select.dataset.ezySelReady = '1';

      const id = `ezysel-${seq += 1}`;
      const wrap = document.createElement('div');
      wrap.className = 'ezysel';
      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'ezysel__trigger';
      trigger.id = `${id}-trigger`;
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.innerHTML = `<span class="ezysel__value"></span>${CARET}`;
      const panel = document.createElement('ul');
      panel.className = 'ezysel__panel';
      panel.id = `${id}-panel`;
      panel.setAttribute('role', 'listbox');
      panel.hidden = true;

      const labelledBy = select.getAttribute('aria-labelledby');
      const labelFor = select.id ? document.querySelector(`label[for="${select.id}"]`) : null;
      if (labelledBy) trigger.setAttribute('aria-labelledby', labelledBy);
      else if (labelFor) {
        if (!labelFor.id) labelFor.id = `${id}-label`;
        trigger.setAttribute('aria-labelledby', labelFor.id);
        panel.setAttribute('aria-labelledby', labelFor.id);
      } else if (select.getAttribute('aria-label')) {
        trigger.setAttribute('aria-label', select.getAttribute('aria-label'));
        panel.setAttribute('aria-label', select.getAttribute('aria-label'));
      }

      select.parentNode.insertBefore(wrap, select);
      wrap.append(trigger, panel, select);
      // The native select stays as the source of truth but leaves the a11y tree,
      // so screen readers are not told about the same control twice.
      select.classList.add('ezysel__native');
      select.setAttribute('aria-hidden', 'true');
      select.tabIndex = -1;

      let active = -1;

      const options = () => [...select.options];
      const syncTrigger = () => {
        const chosen = select.options[select.selectedIndex];
        const text = chosen ? chosen.textContent.trim() : '';
        trigger.querySelector('.ezysel__value').textContent = text;
        // A blank value means "nothing picked yet" — the placeholder option.
        trigger.classList.toggle('ezysel__trigger--empty', !chosen || chosen.value === '');
        trigger.disabled = select.disabled;
        if (select.disabled) close();
      };

      const paint = () => {
        panel.innerHTML = '';
        options().forEach((option, index) => {
          const row = document.createElement('li');
          row.className = 'ezysel__opt';
          row.setAttribute('role', 'option');
          row.id = `${id}-opt-${index}`;
          row.setAttribute('aria-selected', String(index === select.selectedIndex));
          row.classList.toggle('ezysel__opt--active', index === active);
          row.innerHTML = `${TICK}<span>${option.textContent.trim()}</span>`;
          row.addEventListener('click', () => pick(index));
          row.addEventListener('mousemove', () => setActive(index));
          panel.appendChild(row);
        });
      };

      const setActive = (index) => {
        const list = options();
        if (!list.length) return;
        active = Math.max(0, Math.min(index, list.length - 1));
        [...panel.children].forEach((row, i) => {
          row.classList.toggle('ezysel__opt--active', i === active);
        });
        panel.setAttribute('aria-activedescendant', `${id}-opt-${active}`);
        panel.children[active]?.scrollIntoView({ block: 'nearest' });
      };

      const open = () => {
        if (select.disabled || panel.hidden === false) return;
        active = select.selectedIndex;
        paint();
        panel.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        setActive(active);
      };

      function close() {
        if (panel.hidden) return;
        panel.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        panel.removeAttribute('aria-activedescendant');
      }

      const pick = (index) => {
        select.selectedIndex = index;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
        syncTrigger();
        close();
        trigger.focus();
      };

      trigger.addEventListener('click', () => (panel.hidden ? open() : close()));

      trigger.addEventListener('keydown', (event) => {
        switch (event.key) {
          case 'ArrowDown': case 'ArrowUp': case 'Enter': case ' ':
            event.preventDefault();
            if (panel.hidden) open();
            else setActive(active + (event.key === 'ArrowUp' ? -1 : 1));
            break;
          case 'Home': case 'End':
            if (!panel.hidden) { event.preventDefault(); setActive(event.key === 'Home' ? 0 : options().length - 1); }
            break;
          case 'Escape':
            close();
            break;
          case 'Tab':
            close();
            break;
          default:
            break;
        }
      });

      // Enter and Space confirm the highlighted row; the keydown above already
      // opened the panel, so this only fires while it is open.
      trigger.addEventListener('keyup', (event) => {
        if (panel.hidden) return;
        if (event.key === 'Enter' || event.key === ' ') pick(active);
      });

      document.addEventListener('click', (event) => {
        if (!wrap.contains(event.target)) close();
      });

      // The caravan cascade rewrites options and flips `disabled` as the shopper
      // moves through Series -> Mark -> Model.
      new MutationObserver(() => {
        syncTrigger();
        if (!panel.hidden) paint();
      }).observe(select, { childList: true, attributes: true, attributeFilter: ['disabled'] });

      select.addEventListener('change', syncTrigger);
      syncTrigger();
    };

    const scan = () => document.querySelectorAll('select[data-ezy-select]').forEach(enhance);
    scan();
    document.addEventListener('shopify:section:load', scan);
  })();
  } catch(e) { console.error(e); }
})();

})();
